module.exports = __webpack_public_path__ + "static/findanherb-app-hero-ab30b5840ff087d5b71c7aa83f97733f.gif";